export const ROUTES_ROOT = '/kredity';
export const ROUTES_NEW_ROOT = '/kredity-new';
export const ROUTES_BANK_ROOT = '/bank';
